export const COLORS = {
  primary: "#4f74fe",
  semaforoOk: localStorage.getItem("colorSemaforoOk") ?? "#9fdfad",
  semaforoWarning: localStorage.getItem("colorSemaforoWarning") ?? "#ffeb79",
  semaforoNotOk: localStorage.getItem("colorSemaforoNotOk") ?? "#ff6586",
  white: "#fff",
  botonGris: "rgb(0, 0, 0, 0.56)",
  carbohidratos:
    localStorage.getItem("colorCarbohidratos") ?? "rgba(91,240,160,94)",
  lipidos: localStorage.getItem("colorLipidos") ?? "rgba(240,216,79,94)",
  proteinas: localStorage.getItem("colorProteinas") ?? "rgba(240,138,127,94)",
  buttonGreen: "#eefcf1",
  buttonGreenUp: "#3fda61",

  // your colors
};

Object.keys(COLORS).forEach((key) => {
  document.documentElement.style.setProperty(`--color-${key}`, COLORS[key]);
});
